import React from "react";
import styled from "styled-components";
import {
    read_timeline_actor_label,
    read_timeline_date_label
} from "../../utils/timeline/timeline_formatting";

const TimelineBrandCreated = styled.section`
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.8rem 1.2rem;
    min-width: 0;
    padding: 1rem;
    border: 0.1rem solid ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    background: ${p => p.theme.background};
    font-family: "fontMedium", sans-serif;
`;

const TimelineBrandCreatedOrigin = styled.p`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem;
    min-width: 0;
    color: ${p => p.theme.color};

    span,
    strong {
        color: inherit;
        overflow-wrap: anywhere;
    }
`;

const TimelineBrandCreatedTimestamp = styled.time`
    min-width: 0;
    color: ${p => p.theme.color};
    text-align: right;
    overflow-wrap: anywhere;
    white-space: normal;
`;

// Detects creation performed by an integration rather than a signed-in member.
const read_brand_creation_is_automated = (event) => {
    const actor = event?.by || {};
    const actorType = `${actor.type || actor.kind || actor.role || ""}`.trim().toLowerCase();
    const actorIdentities = [
        actor.name,
        actor.email,
        actor.username,
        actor.userId,
        actor.id
    ].map((value) => `${value || ""}`.trim().toLowerCase()).filter(Boolean);

    return event?.data?.automated === true
        || ["automation", "bot", "service", "system"].includes(actorType)
        || !actorIdentities.length
        || actorIdentities.some((identity) => identity === "system" || identity.startsWith("system@"));
};

// Shows only when the Brand was created and whether a user initiated it.
export const Timeline_Brand_Created = (props) => {
    const automated = read_brand_creation_is_automated(props.event);
    const actor = read_timeline_actor_label(props.event, props.t);

    return (
        <TimelineBrandCreated data-testid="timeline-brand-created" aria-label={props.t("Brand creation details")}>
            <TimelineBrandCreatedOrigin>
                {automated ? (
                    <strong>{props.t("Automated")}</strong>
                ) : (
                    <>
                        <span>{props.t("Added by")}</span>
                        <strong>{actor}</strong>
                    </>
                )}
            </TimelineBrandCreatedOrigin>
            <TimelineBrandCreatedTimestamp dateTime={props.event?.changedAt || undefined}>
                {read_timeline_date_label(props.event?.changedAt) || props.t("Date unavailable")}
            </TimelineBrandCreatedTimestamp>
        </TimelineBrandCreated>
    );
};
